import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular-ivy";
import { environment } from './app/environments/environment';
import { versions } from 'projects/versions';

if (environment.envName == 'prod') {

  Sentry.init({
    dsn: "https://fb4d2f3735e406d5f923268682d4c87d@o330358.ingest.us.sentry.io/4509405700489216",
    integrations: [
      new Sentry.BrowserTracing({
        tracingOrigins: ['localhost:4200', 'https://app.vergleichsofferten.ch'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    ignoreErrors: ["Cannot read properties of undefined (reading 'domInteractive')"],
    environment: environment.envName,
    tracesSampleRate: 0.1,
    beforeSend: (event) => {
      const exception = event.exception?.values && event.exception?.values[0]
      if (exception?.value === 'Non-Error exception captured with keys: currentTarget, isTrusted, target, type') {
        return null;
      }
      return event;
    }
  });
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    console.log(`Bootstrap success: ${versions.hash}, ${versions.date}`);
  })
  .catch(err => console.error(err));
